import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { AceEditorComponent } from 'ngx-ace-editor-wrapper';
// Service
import { NexsysMonitorService } from '../../../service/nexsys-monitor.service';
import { BroadcastService,  } from '@cv-invision/core';
import { CvDateFormatter, DATEFORMAT, DIFFUNITS} from '@cv-invision/cv.component-library.ux';
// Model
import {
	AbstractModal,
	ModalButtonModel,
	ModalButtonType,
	ModalService,
	ToasterType
} from '@cv-invision/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'cv-invision-orders-log',
	templateUrl: './orders-log.component.html',
	styleUrls: ['./orders-log.component.scss']
})
export class OrdersLogComponent extends AbstractModal implements OnInit, OnDestroy {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	@ViewChild('markupEditor', { static: false }) markupEditor: AceEditorComponent;
	@ViewChild('markupEditor', { static: false }) markupEditor2: AceEditorComponent;

	orderInfo: any;
	orderAcuityInfo: any;
	appScopeMsgRequest: string;
	acuityMsgRequest: string;
	creationUserName: string;
	copyAppScopeMsgRequest: Array<ModalButtonModel>;
	copyAcuityMsgRequest: Array<ModalButtonModel>;
	inProcessRequeueAppScope:boolean;
	inProcessRequeueAcuity:boolean;
	acuityInstance: string;

	constructor(
		private nexsysMonitor: NexsysMonitorService,
		private modalService: ModalService,
		private broadcastService: BroadcastService,
		private clipboarService: ClipboardService,
		private dateService: CvDateFormatter
	) {
		super();
		this.acuityInstance = 'Acuity';
	}

	ngOnInit(): void {
		this.nexsysMonitor
			.getOrderDetail(this.data.product)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(response => {
				this.data = response;
				if (this.data && this.data.appScope) {
					this.orderInfo = [
						{ name: 'AppraisalId', value: this.data.appScope.appraisalId },
						{ name: 'FileNumber', value: this.data.appScope.appraisalFileNumber },
						{
							name: 'Transaction Status',
							value: this.data.appScope.asyncResponse ? this.data.appScope.asyncResponse.status : null
						},
						{
							name: 'Transaction Response',
							value: this.data.appScope.asyncResponse
								? this.data.appScope.asyncResponse.message
								: null
						},
						{
							name: 'Transaction Request Date',
							value: this.data.appScope.asyncResponse
								? this.dateService.format(DATEFORMAT.EMPTY,this.data.appScope.asyncResponse.lastUpdated)
								: null
						}
					];
					this.inProcessRequeueAppScope = this.canRequeueInprocess(this.data.appScope.asyncResponse.lastUpdated, this.data.appScope.asyncResponse.status);
					const json = this.data.appScope.asyncResponse
						? this.data.appScope.asyncResponse.messageRequest
						: null;
					this.creationUserName = this.data.appScope.creationUserName || '';
					this.appScopeMsgRequest = this.parseJsonData(json);
				}

				if (this.data && this.data.acuity) {
					this.acuityInstance = this.data.acuity?.instance === 'cmpacuity' ? 'CmpAcuity' : 'Acuity';

					this.orderAcuityInfo = [
						{ name: 'OrderId', value: this.data.acuity.orderId },
						{ name: 'BranchId', value: this.data.acuity.branchId },
						{
							name: 'Transaction Status',
							value: this.data.acuity.asyncResponse
								? this.data.acuity.asyncResponse.status
								: null
						},
						{
							name: 'Transaction Response',
							value: this.data.acuity.asyncResponse
								? this.data.acuity.asyncResponse.message
								: null
						},
						{
							name: 'Transaction Request Date',
							value: this.data.acuity.asyncResponse
								? this.dateService.format(DATEFORMAT.EMPTY,this.data.acuity.asyncResponse.lastUpdated)
								: null
						}
					];
					this.inProcessRequeueAcuity = this.canRequeueInprocess(this.data.acuity.asyncResponse.lastUpdated, this.data.acuity.asyncResponse.status);
					const json = this.data.acuity.asyncResponse
						? this.data.acuity.asyncResponse.messageRequest
						: null;
					this.acuityMsgRequest = this.parseJsonData(json);
				}
			});

		this.copyAppScopeMsgRequest = [];
		const resquestButton: ModalButtonModel = {
			class: 'copy-button',
			icon: 'fad fa-copy',
			type: ModalButtonType.ACTION,
			action: () => this.onCopycode(this.appScopeMsgRequest)
		};
		this.copyAppScopeMsgRequest.push(resquestButton);

		this.copyAcuityMsgRequest = [];
		const responseButton: ModalButtonModel = {
			class: 'copy-button',
			icon: 'fad fa-copy',
			type: ModalButtonType.ACTION,
			action: () => this.onCopycode(this.acuityMsgRequest)
		};
		this.copyAcuityMsgRequest.push(responseButton);

		const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onCancel.bind(this)
		};
		this.buttons.push(cancelButton);
	}

	canRequeueInprocess(time:string,status:string):boolean {
		let canEnquee = false;
		const diffHours = this.dateService.diff([this.dateService.dayJs().toString(),time],DIFFUNITS.HOUR);
		if(diffHours >= 5 && status === 'INPROCESS') {
			canEnquee = true;
		}
		return canEnquee;
	}

	onDismiss(): void {
		super.onCancel();
	}

	/**
	 * parse josn strin from the server
	 * @param info
	 */
	parseJsonData(info: string): string {
		try {
			return JSON.stringify(JSON.parse(info), null, 3);
		} catch (e) {
			return JSON.parse(JSON.stringify(info, null, 1));
		}
	}

	/***
	 * copy response code
	 */
	onCopycode(source: string): void {
		this.clipboarService.copy(source);
	}

	/**
	 * reEnqueue confirmation Order
	 */
	reEnqueueConfirmationOrder(source: string): void {
		let url: any;
		let payload: any;
		if (source === 'appScope') {
			url = `appscope/create-order?creationUserName=${this.creationUserName}`;
			payload = this.appScopeMsgRequest;
		}
		if (source === 'acuity') {
			url = 'acuity/create-order';
			payload = this.acuityMsgRequest;
		}

		if (source === 'cmpacuity') {
			url = 'cmpacuity/create-order';
			payload = this.acuityMsgRequest;
		}

		this.modalService
			.customConfirm(
				'Re-queue Order',
				`Do you really want to re-queue? This process will generate another order into ${source}.`,
				'icon-warning fas fa-exclamation-circle',
				'ReEnqueue',
				'cv-btn-link-error'
			)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.confirm === 'confirm') {
					this.reEnqueueOrder(url, payload);
				}
			});
	}

	/**
	 * sent request for re-queue te current order
	 */
	reEnqueueOrder(url: string, payload: any): void {
		this.nexsysMonitor
			.reEnqueueOrderTransations(url, payload)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				response => {
					this.successHandleFunction();
					super.onCancel();
				},
				error => {
					this.errorMsgFunction(error.message || error.error || error.Message || error.Error);
					super.onCancel();
				}
			);
	}
	/**
	 * handle response from server
	 */
	successHandleFunction(): void {
		const msg = `The order was re-queue successfully`;
		this.broadcastService.broadcast({
			name: ToasterType.SUCCESS,
			event: { message: msg }
		});
	}

	/**
	 * Display error message wheter the oparation wast´n success
	 * @param error
	 */
	errorMsgFunction(error: string): void {
		this.broadcastService.broadcast({
			name: ToasterType.ERROR,
			event: { error }
		});
	}

	/**
	 * On component destroy
	 */
	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
